import styled from 'styled-components';
export const ReportContainer = styled.div`
  min-height: 580px;
`;